import React, { FC } from 'react'

import { ArtistAvatar, ConditionRender, GpsBadge } from 'components'
import { ProjectItem } from 'modules/Projects/components'

import { IProject } from 'shared/interfaces'

import { IArtistItemProps } from './ArtistItem.props'
import './ArtistItem.scss'

const ArtistItem: FC<IArtistItemProps> = ({ artist, units }) => (
  <div className="project-list-item">
    <div className="project-list-item__header">
      <ArtistAvatar
        className="project-list-item__avatar"
        spotifyId={artist.spotify_id}
        facebookId={artist.facebook_id}
        size="m"
      />
      <div className="project-list-item__info">
        <h5 className="project-list-item__title">{artist.name}</h5>
        <div className="project-list-item__badge">
          <ConditionRender
            condition={!!artist.gps_status}
            component={<GpsBadge gpsStatus={artist.gps_status} coloredBackground />}
          />
        </div>
      </div>
    </div>
    {artist.campaigns.map((project: IProject) => (
      <ProjectItem key={project.id} project={project} units={units} artistName={artist.name} />
    ))}
  </div>
)

export default ArtistItem
